export default __webpack_public_path__ + "assets/en-US.03b55a53bc04f178c00710f34e74015d.svg";